import { FormGroup } from '@angular/forms';

export class DataHelper {
  public static props = {
    Nazwa: 'name',
    Typ: 'offerType',
    'Comarch ID': 'code',
    Status: 'status',
    'Okres zobowiązania': 'loyaltyPeriod',
    'Okres rozliczeniowy': 'billingPeriod',
    'Cena aktywacji': 'activationPrice',
    Regulamin: 'linkToTermsOfService',
    'Oferta ważna od': 'availableSince',
    'Oferta ważna do': 'availableUntil',
    'Dostępna dla lokalizacji': 'availableInLocations',
    'Dostępna dla kanałów': 'availableInChannels',
    'Dostępna dla segmentu klienta': 'availableForCustomerSegments',
    Etykiety: 'tags'
  };

  public static productCategories() {
    return {
      ott: 'ott',
      ottBox: 'ott box',
      internet: 'internet',
      tv: 'telewizja',
      hardware: 'urządzenia',
      premium: 'premium',
      telephone: 'telefon',
      mobileInternet: 'internet mobilny',
      mobile: 'telefon komórkowy',
      extra: 'dodatki',
      mobileplan: 'mobileplan'
    };
  }

  public static mapHeadersToProp(value: string): string {
    return this.props[value];
  }

  public static mapPropsToHeader(value: string): string {
    return Object.keys(this.props).find(key => this.props[key] === value);
  }

  public static getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  public static AtLeastOneFieldValidator(group: FormGroup): { [key: string]: any } {
    let isAtLeastOne = false;
    if (group && group.controls) {
      for (const control in group.controls) {
        if (group.controls.hasOwnProperty(control) && group.controls[control].valid && group.controls[control].value) {
          isAtLeastOne = true;
          break;
        }
      }
    }
    return isAtLeastOne ? null : { required: true };
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/data-helper.ts